import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { SubsUser } from '../../../../common-services/user-management.service';
import { AuthenticationService } from '../../../auth/auth.service';
import { UserService } from '../../../../common-services/user.service';
import { ADUser, EsriUserService } from '../../../../common-services/esri-user.service';

export interface ModalUserADInput {
	existingUsers: SubsUser[]
}

@Component({
	selector: 'app-modal-users-ad',
	templateUrl: './modal-users-ad.component.html',
	styleUrls: ['./modal-users-ad.component.css']
})
export class ModalUsersAdComponent implements OnInit {

	public users: ADUser[] = [];
	public selectedUser;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ModalUserADInput,
		public dialogRef: MatDialogRef<ModalUsersAdComponent>,
		private esriUserService: EsriUserService,
		private userService: UserService
	) { }

	async ngOnInit() {
		const existingUsers = this.data.existingUsers || [];
		const users = await this.esriUserService.getExternalUserList(this.userService.getUserInfo().adminEmails[0]) || [];
		this.users = users.filter(u => {
			return !existingUsers.find(e => e.userEmail.toLowerCase() === u.email.toLowerCase());
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/user-manage/modal-users-ad/modal-users-ad.component.ts